var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticClass: "file-explorer-popup",
      attrs: { title: "Detalhes", active: _vm.isVisible },
      on: {
        "update:active": function($event) {
          _vm.isVisible = $event
        }
      }
    },
    [
      _vm.item
        ? _c("div", { staticClass: "item-details" }, [
            _c("div", { staticClass: "detail-row" }, [
              _c("strong", [_vm._v("Nome:")]),
              _c("span", [_vm._v(_vm._s(_vm.item.name))])
            ]),
            _c("div", { staticClass: "detail-row" }, [
              _c("strong", [_vm._v("Tipo:")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.item.type === "directory"
                      ? "Pasta"
                      : _vm.item.type === "drive"
                      ? "Drive"
                      : _vm.formatFileType(_vm.item)
                  )
                )
              ])
            ]),
            _vm.item.type === "file"
              ? _c("div", { staticClass: "detail-row" }, [
                  _c("strong", [_vm._v("Tamanho:")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.formatFileSize(_vm.item.size)))
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "detail-row" }, [
              _c("strong", [_vm._v("Proprietário:")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.item.is_owner ? "Eu" : _vm.item.owner_name || "--")
                )
              ])
            ]),
            _vm.item.modified
              ? _c("div", { staticClass: "detail-row" }, [
                  _c("strong", [_vm._v("Modificado:")]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.formatDate(_vm.item.modified)))
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "footer-dialog justify-end" },
        [
          _c(
            "div",
            { staticClass: "action-buttons" },
            [_vm._t("footer-actions")],
            2
          ),
          _c(
            "b-button",
            {
              attrs: { variant: "outline-secondary" },
              on: { click: _vm.close }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-1",
                attrs: { icon: "XIcon", size: "16" }
              }),
              _vm._v(" Fechar ")
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }